import { roundToPlaces } from "./numbers";

export function stringSorter(a: string, b: string) {
  if (a < b) {
    return -1;
  }
  if (b < a) {
    return 1;
  }

  return 0;
}

export function timeSince(millisSince: number) {
  var seconds = Math.floor(millisSince / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
}

export function capitalize(input: any) {
  let str = input.toString() as string;
  var firstChar = str[0];

  if (!firstChar) {
    return "";
  }
  str = firstChar.toUpperCase() + str.slice(1);
  return str.replace(/([a-z])([A-Z])/g, "$1 $2");
  //const camelSplit = str.split(/(?<=[a-z])(?=[A-Z ])/);
  //return camelSplit.map((word) => {
  //  var firstChar = word[0];
  //
  //  if (!firstChar) {
  //    return "";
  //  }
  //
  //  return firstChar.toUpperCase() + word.slice(1);
  //})
  //  .join(" ");
}

const formatterCache: Record<string, Record<string, Intl.NumberFormat>> = {};

export function formatPercentNumber(val?: number) {
  return roundToPlaces(val ?? 0, 2) +
    "%";
}

export function currency(
  input?: number,
  fractionDigits: number = 0,
  locale: string = "en-US",
  currency: string = "USD",
) {
  let localeCache = formatterCache[locale];
  if (!localeCache) {
    localeCache = formatterCache[locale] = {};
  }

  let formatter = localeCache[currency];

  if (!formatter) {
    formatter = localeCache[currency] = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      maximumFractionDigits: fractionDigits,
    });
  }

  return formatter.format(input ?? 0);
}

export function date(
  input: string,
) {
  var date = new Date(input);

  return date.toLocaleDateString();
}

export function simplify(input: string) {
  return input.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
}

export function formatSSN(ssn: string) {
  // remove all non-dash and non-numerals
  var val = ssn.replace(/[^\d-]/g, "");

  // add the first dash if number from the second group appear
  val = val.replace(/^(\d{3})-?(\d{1,2})/, "$1-$2");

  // add the second dash if numbers from the third group appear
  val = val.replace(/^(\d{3})-?(\d{2})-?(\d{1,4})/, "$1-$2-$3");

  // remove misplaced dashes
  val = val.split("").filter((val, idx) => {
    return val !== "-" || idx === 3 || idx === 6;
  }).join("");

  // enforce max length
  return val.substring(0, 11);
}

export function formatPercent(val: string | number) {
  if (typeof val == "number") {
    return val + "%";
  } else if (typeof val != "string") {
    return "0%";
  }
  // remove all non-dash and non-numerals
  val = val.replace(/[^\d]/g, "");

  val = val.replace(/^0+/, "");

  if (val.length == 0) {
    return "0";
  }
  var value = parseInt(val);
  if (value > 100) {
    return "100";
  }

  // enforce max length
  return val.substring(0, 3);
}

export function displayMoney(val: string, allowNegative: boolean = true) {
  return val == "-"
    ? "-"
    : val == ""
      ? currency(0)
      : currency(allowNegative ? parseInt(val) : Math.max(0, parseInt(val)));
}

export function formatMoney(val: string) {
  // remove all non-dash and non-numerals
  var val = val.replace(/[^\d-]/g, "");

  // remove all non-leading dashes
  val = val.replace(/(?<=.)-/, "");

  // remove all leading zeros
  val = val.replace(/^0+/, "");

  if (val.length == 0) {
    return "0";
  }

  return val == "-" ? "-" : val;
}
